import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AppService from '../services/app.service';

interface Props {
  id?: string;
  name?: string;
  description?: string;
  title?: string;
  type?: string;
  image?: string;
  url?: string;
  children?: React.ReactNode;
                    
}

export const SEO: React.FunctionComponent<Props> = (props) => {
  const [imagePath, setImagePath] = React.useState('');
  const [imageHeight, setImageHeight] = React.useState(0);
  const [imageWidth, setImageWidth] = React.useState(0);

  const path = props.image || '/assets/thumbnail.png';
  const [image, setImage] = React.useState<any>();

  React.useEffect(() =>  {
    AppService.checkIsImage(path).then(rp => setImage(rp));
    if (image) {
      setImagePath(path);
      setImageHeight(image.height || 0);
      setImageWidth(image.width);
    }

  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <meta property='og:type' content={props.type || 'article'} />
        <meta property='og:title' content={props.title || document.title} />
        <meta property='og:description' content={props.description || document.title} />
        <meta property='og:url' content={props.url || window.location.origin}/>
        <meta property='og:image' content={window.location.origin + imagePath}/>
        <meta property='og:image:height' content={`${imageHeight}`}/>
        <meta property='og:image:width' content={`${imageWidth}`} />
        <meta property='og:image:type' content='image/png' />
      </Helmet>
    </HelmetProvider>
  )
}


